export default "__VITE_ASSET__CIGswVpR__"